import React from 'react';
import { ArcStack } from '@src/core/ui';
import { SelectedDrone } from '@src/features/drone/components/selected-drone';
import { TopDronesCarousel } from '@src/features/drone/components/top-drones-carousel';
import { WinchControl } from '@src/features/drone/components/winch-control';
import {
  EnRouteFlightMode,
  EnRouteIndicator,
  EnRouteStatusMessage,
  JoystickView,
} from '@src/features/order/pages/take-off-to-en-route-page/components';
import FlightData from '@src/features/drone/components/flight-data';
import { ArcBaseSidebar } from '@src/core/components';
import { MissionDetails } from '@src/features/drone/components/mission-details';
import EmergencyButtons from '@src/features/drone/components/emergency-control';
import EnRouteManualControl from '@src/features/drone/pages/drones-page/components/en-route-manual-control';
import { Sections } from '@src/features/drone/pages/drones-page/components/sections';
import { useSelector } from 'react-redux';
import { selectManualControlMap } from '@src/features/drone/redux/selectors';
import { useDronesPage } from '@src/features/drone/context/drones-page-view-model';

const DronesSidebar: React.FC = () => {
  const vm = useDronesPage();
  const manualControl = useSelector(selectManualControlMap);

  return (
    <ArcBaseSidebar>
      <ArcStack spacing={2}>
        {vm.selectedDrone && (
          <TopDronesCarousel
            idleDrones={vm.idleDrones}
            flyingDrones={vm.flyingDrones}
            selectedDrone={vm.selectedDrone}
            flightData={vm.flightData}
          />
        )}
        {vm.selectedDrone ? (
          <SelectedDrone
            drone={vm.selectedDrone}
            isOnMission={vm.isOnMission}
            isStrictMission={vm.isStrictMission}
          />
        ) : (
          <Sections
            idleDrones={vm.idleDrones}
            missionDrones={vm.flyingDrones}
            updateRequiredDrones={vm.updateRequiredDrones}
          />
        )}
        {vm.isOnMission && vm.selectedDrone && (
          <EmergencyButtons
            drone={vm.selectedDrone}
            isLoading={vm.isOrderLoading}
            missionId={vm.sidebarMissionId}
          />
        )}
        {vm.selectedDrone && (
          <ArcStack spacing={2}>
            <ArcStack spacing={1} direction='row' justifyItems='center' alignItems='center'>
              <FlightData order={vm.order} droneSerial={vm.selectedDrone.serialNumber} />
              <EnRouteIndicator />
            </ArcStack>
            <EnRouteStatusMessage missionId={vm.sidebarMissionId} />
            <EnRouteFlightMode missionId={vm.sidebarMissionId} />
          </ArcStack>
        )}
        {vm.selectedDrone && <WinchControl droneId={vm.selectedDrone.id.toString()} />}
        {vm.selectedDrone && vm.order && vm.orderId && <MissionDetails order={vm.order} />}
        {vm.selectedDrone && (
          <ArcStack spacing={2}>
            <EnRouteManualControl
              drone={vm.selectedDrone}
              missionId={vm.sidebarMissionId}
            />
            <JoystickView
              drone={vm.selectedDrone}
              isManualControl={manualControl[vm.selectedDrone.serialNumber]}
            />
          </ArcStack>
        )}
      </ArcStack>
    </ArcBaseSidebar>
  );
};

export default DronesSidebar;
